import axios from "axios";
import accessControl from "../../models/gestionTiempos/accessControl";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAccessControl(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let fecha = data.date;
    let iniDia = data.startDay;
    let finDia = data.endDay;
    let empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/regis/caMovim/${empId}&${fecha}&${iniDia}&${finDia}`, {
        headers,
      })
      .then(({ data }) =>
        data.map((item) => {
          return accessControl.fromJson(item);
        })
      );
  }
}
export default service;
